/* Legal translations are reviewed local content, separate from interface labels. */
(() => {
  const article = document.querySelector('.legal-copy');
  if (!article) return;
  const page = window.KM.page;
  const german = article.innerHTML;
  const supported = ['de', 'en', 'ku', 'tr', 'ar'];
  let contents = null;
  let selected = document.documentElement.lang;
  function apply() {
    const language = supported.includes(selected) ? selected : 'de';
    if (language !== 'de' && !contents) return;
    const html = language === 'de' ? german : contents[language]?.[page];
    if (!html) return;
    article.innerHTML = html;
    article.lang = language;
    article.dir = language === 'ar' ? 'rtl' : 'ltr';
  }
  document.addEventListener('sitelanguagechange', event => {
    selected = event.detail.language;
    apply();
  });
  fetch(window.KM.asset('/legal-content.json?v=33'))
    .then(response => { if (!response.ok) throw new Error('Legal translations'); return response.json(); })
    .then(data => { contents = data; selected = document.documentElement.lang; apply(); })
    .catch(() => {
      // Preserve the readable original and explicitly identify any loading failure.
      const message = document.createElement('p');
      message.className = 'legal-translation-error';
      message.lang = 'de';
      message.dir = 'ltr';
      message.setAttribute('translate', 'no');
      message.textContent = 'Die Übersetzung konnte nicht geladen werden. Bitte lade die Seite erneut. Bis dahin siehst du den deutschen Originaltext.';
      article.before(message);
    });
})();
